// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3zDwJ","colCheckbox":"styles_colCheckbox__1ULA4"};